import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg
      class="icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      [attr.data-icon]="name"
    >
      @switch (name) {
        @case ('angular') {
          <path
            d="M12 2 2.4 5.5 4.2 18 12 22l7.8-4 1.8-12.5L12 2Zm0 2.2 6.1 2.4-1.3 8.7L12 18.6 7.2 15.3 5.9 6.6 12 4.2Zm0 3.1-3.1 7.3h1.7l.6-1.6h3.6l.6 1.6h1.7L12 7.3Zm0 3.1 1 2.5h-2l1-2.5Z"
          />
        }
        @case ('code') {
          <path
            d="M8.2 16 4 12l4.2-4L6.8 6.6 1.4 12l5.4 5.4L8.2 16Zm7.6 0 1.4 1.4L22.6 12l-5.4-5.4-1.4 1.4L19.9 12l-4.1 4Z"
          />
        }
        @case ('palette') {
          <path
            d="M12 3a9 9 0 1 0 0 18h3a2 2 0 0 0 0-4h-1.5a1.5 1.5 0 0 1 0-3H16a5 5 0 0 0 0-10h-4Zm-4 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm3-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm3 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
          />
        }
        @case ('wave') {
          <path
            d="M3 12c2.5 0 2.5-4 5-4s2.5 4 5 4 2.5-4 5-4 2.5 4 5 4v2c-2.5 0-2.5-4-5-4s-2.5 4-5 4-2.5-4-5-4-2.5 4-5 4v-2Z"
          />
        }
        @case ('server') {
          <path
            d="M4 4h16a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 9h16a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2Zm3-6h2v2H7V7Zm0 9h2v2H7v-2Z"
          />
        }
        @case ('layers') {
          <path d="M12 3 2.5 8 12 13l9.5-5L12 3Zm0 7L2.5 15 12 20l9.5-5L12 10Z" />
        }
        @case ('network') {
          <path
            d="M5 9a3 3 0 1 0 0 6h2v2H5a5 5 0 0 1 0-10h2v2H5Zm12-2h2a5 5 0 1 1 0 10h-2v-2h2a3 3 0 1 0 0-6h-2V7ZM8 11h8v2H8v-2Z"
          />
        }
        @case ('mobile') {
          <path
            d="M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 3v14h8V5H8Zm4 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
          />
        }
        @case ('database') {
          <path
            d="M12 3c-4.4 0-8 1.3-8 3s3.6 3 8 3 8-1.3 8-3-3.6-3-8-3Zm-8 7v4c0 1.7 3.6 3 8 3s8-1.3 8-3v-4c-1.8 1.2-5 2-8 2s-6.2-.8-8-2Zm0 6v4c0 1.7 3.6 3 8 3s8-1.3 8-3v-4c-1.8 1.2-5 2-8 2s-6.2-.8-8-2Z"
          />
        }
        @case ('box') {
          <path
            d="M12 2 3 6.5v11L12 22l9-4.5v-11L12 2Zm0 2.3 6.5 3.3L12 11 5.5 7.6 12 4.3Zm-7 5.4 6 3.1v7.2l-6-3V9.7Zm14 0v7.3l-6 3v-7.2l6-3.1Z"
          />
        }
        @case ('cloud') {
          <path d="M7.5 18A4.5 4.5 0 0 1 7 9a5 5 0 0 1 9.8-1.3A4 4 0 1 1 18 18H7.5Z" />
        }
        @case ('pipeline') {
          <path
            d="M4 5h6v4H4V5Zm10 0h6v4h-6V5ZM4 15h6v4H4v-4Zm10 0h6v4h-6v-4ZM10 7h4v2h-4V7Zm0 8h4v2h-4v-2Z"
          />
        }
        @case ('pen') {
          <path
            d="M3 21h4l11-11-4-4L3 17v4Zm14.7-14.3 1.6-1.6a1.1 1.1 0 0 0 0-1.6L17.5 2a1.1 1.1 0 0 0-1.6 0L14.3 3.6l3.4 3.1Z"
          />
        }
        @case ('spark') {
          <path d="M12 2 14 8l6 2-6 2-2 6-2-6-6-2 6-2 2-6Z" />
        }
        @default {
          <circle cx="12" cy="12" r="4" />
        }
      }
    </svg>
  `,
  styles: [
    `
      .icon {
        width: 22px;
        height: 22px;
        fill: currentColor;
      }
    `
  ]
})
export class IconComponent {
  @Input({ required: true }) name!: string;
}
